// App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './app/home';
import PerfilCalculaterLoja from './app/perfilcalculaterloja';
import useGeolocation from './hooks/useGeolocation';

function App() {
  const { error } = useGeolocation();

  useEffect(() => {
    if (error) {
      alert(
        'Nosso cálculo utiliza a sua localização (UF) para garantir maior precisão. Por favor, ative a localização no navegador.'
      );
    }
  }, [error]);

  return (
    <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:storeId/:docRefAvaliacao" element={<PerfilCalculaterLoja />} />
          <Route path="/:storeId" element={<PerfilCalculaterLoja />} />
          <Route path="/:docRefAvaliacao" element={<Home />} />
        </Routes>

    </Router>
  );
}

export default App;
